var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{attrs:{"border":"","auto-resize":"","resizable":"","highlight-hover-row":"","data":_vm.data,"columns":_vm.tableColumns,"height":300,"size":"small"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }